<ng-container screenAnalytics="lotam-edit">
    <div class="modal-body">
        <enhanced-help componentName="screen" [compact]="true"></enhanced-help>
        <div class="row">
            <div class="col-md-6">
                <div class="form-horizontal" [formGroup]="lotamForm">
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="lotamForm.controls.subject"
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                LOTAM Subject
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <input
                                class="form-control"
                                formControlName="subject"
                                placeholder="Type a name for this LOTAM"
                                [readonly]="working"
                            />
                            <validation-messages
                                validatorFormControlName="subject"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help componentName="subject"></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="lotamForm.controls.description"
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                Description
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <textarea
                                class="form-control"
                                formControlName="description"
                                [readonly]="working"
                            ></textarea>
                            <validation-messages
                                validatorFormControlName="description"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help componentName="description"></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="lotamForm.controls.noticeType"
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                Type
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <ng-select
                                [items]="noticeTypes"
                                bindLabel="name"
                                formControlName="noticeType"
                                [clearable]="true"
                                [readonly]="working"
                            >
                            </ng-select>
                            <validation-messages
                                validatorFormControlName="noticeType"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help componentName="noticeType"></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="lotamForm.controls.startTime"
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                Start Time
                            </label>
                        </div>
                        <div
                            class="col-xs-8 horizontal-container vertical-align"
                        >
                            <div class="input-group">
                                <!-- The min-width on the control below should allow the date to not be cut off -->
                                <input
                                    class="form-control"
                                    style="min-width: 6rem"
                                    type="text"
                                    #datepickerStartTime="bsDatepicker"
                                    bsDatepicker
                                    formControlName="startTime"
                                    [readonly]="working"
                                    [isDisabled]="working"
                                />
                                <span
                                    class="input-group-addon btn-default"
                                    (click)="datepickerStartTime.toggle()"
                                    [attr.aria-expanded]="
                                        datepickerStartTime.isOpen
                                    "
                                >
                                    <i class="glyphicon glyphicon-calendar"></i>
                                </span>
                            </div>
                            <timepicker
                                formControlName="startTime"
                                [hourStep]="1"
                                [minuteStep]="1"
                                [showMeridian]="false"
                                [showSpinners]="false"
                                [readonlyInput]="working"
                            >
                            </timepicker>
                            {{ timeZoneLabel }}
                        </div>
                    </div>
                    <enhanced-help componentName="startTime"></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="lotamForm.controls.endTime"
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                End Time
                            </label>
                        </div>
                        <div
                            class="col-xs-8 horizontal-container vertical-align"
                        >
                            <div class="input-group">
                                <!-- The min-width on the control below should allow the date to not be cut off -->
                                <input
                                    class="form-control"
                                    style="min-width: 6rem"
                                    type="text"
                                    #datepickerEndTime="bsDatepicker"
                                    bsDatepicker
                                    formControlName="endTime"
                                    [readonly]="working"
                                    [isDisabled]="working"
                                />
                                <span
                                    class="input-group-addon btn-default"
                                    (click)="datepickerEndTime.toggle()"
                                    [attr.aria-expanded]="
                                        datepickerEndTime.isOpen
                                    "
                                >
                                    <i class="glyphicon glyphicon-calendar"></i>
                                </span>
                            </div>
                            <timepicker
                                formControlName="endTime"
                                [hourStep]="1"
                                [minuteStep]="1"
                                [showMeridian]="false"
                                [showSpinners]="false"
                                [readonlyInput]="working"
                            >
                            </timepicker>
                            {{ timeZoneLabel }}
                        </div>
                    </div>
                    <enhanced-help componentName="endTime"></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label"> UTC </label>
                        </div>
                        <div
                            *ngIf="lotamForm.controls.startTime.value != null"
                            class="col-xs-8"
                        >
                            {{ utcDateRangeString }}
                        </div>
                    </div>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="lotamForm.controls.upperLimit"
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                Upper Limit
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <div class="input-group">
                                <input
                                    type="number"
                                    min="0"
                                    class="form-control"
                                    formControlName="upperLimit"
                                    [readonly]="working"
                                />
                                <span class="input-group-addon">ft AGL</span>
                            </div>
                            <validation-messages
                                validatorFormControlName="upperLimit"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help componentName="upperLimit"></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="lotamForm.controls.lowerLimit"
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                Lower Limit
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <div class="input-group">
                                <input
                                    type="number"
                                    min="0"
                                    class="form-control"
                                    formControlName="lowerLimit"
                                    [readonly]="working"
                                />
                                <span class="input-group-addon">ft AGL</span>
                            </div>
                            <validation-messages
                                validatorFormControlName="lowerLimit"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help componentName="lowerLimit"></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="
                                        lotamForm.controls.pointOfContact
                                    "
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                Contact Name
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <input
                                class="form-control"
                                formControlName="pointOfContact"
                                [readonly]="working"
                            />
                            <validation-messages
                                validatorFormControlName="pointOfContact"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help
                        componentName="pointOfContact"
                    ></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="
                                        lotamForm.controls
                                            .pointOfContactPhoneNumber
                                    "
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                Contact Phone
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <input
                                class="form-control"
                                formControlName="pointOfContactPhoneNumber"
                                placeholder="Point of Contact Phone Number"
                                [readonly]="working"
                            />
                            <validation-messages
                                validatorFormControlName="pointOfContactPhoneNumber"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help
                        componentName="pointOfContactPhoneNumber"
                    ></enhanced-help>
                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label">
                                <field-validation-indicator
                                    [control]="lotamForm.controls.importance"
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                Priority
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <div class="input-group" style="width: 100%">
                                <ng-select
                                    [items]="priorityOptions"
                                    bindValue="value"
                                    formControlName="importance"
                                    [clearable]="false"
                                    [readonly]="working"
                                ></ng-select>
                            </div>
                            <validation-messages
                                validatorFormControlName="importance"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help componentName="importance"></enhanced-help>

                    <div class="form-group input-content">
                        <div class="col-xs-4">
                            <label class="control-label inline-flex-center">
                                <field-validation-indicator
                                    [control]="
                                        lotamForm.controls
                                            .requiresAcknowledgement
                                    "
                                    [noun]="'field'"
                                    [placement]="'left'"
                                ></field-validation-indicator>
                                <span>Requires Acknowledgement</span>
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <div class="input-group" style="width: 100%">
                                <div
                                    class="input-group"
                                    btnRadioGroup
                                    formControlName="requiresAcknowledgement"
                                    style="padding-top: 5px"
                                >
                                    <label
                                        class="btn btn-xs btn-pill"
                                        [btnRadio]="true"
                                        [disabled]="working"
                                        >Yes</label
                                    >
                                    <label
                                        class="btn btn-xs btn-pill"
                                        [btnRadio]="false"
                                        [disabled]="working"
                                        >No</label
                                    >
                                </div>
                            </div>
                            <validation-messages
                                validatorFormControlName="requiresAcknowledgement"
                            ></validation-messages>
                        </div>
                    </div>
                    <enhanced-help
                        componentName="requiresAcknowledgement"
                    ></enhanced-help>
                </div>
                <div class="input-content top-buffer">
                    <label class="control-label"> Links & Attachments </label>
                    <div class="horizontal-container top-buffer">
                        <div class="fcol-6">
                            <link-manager
                                *ngIf="lotamId"
                                [sectionId]="lotamId"
                                [linkAction]="LinkAction.lotam"
                            >
                            </link-manager>
                        </div>
                        <div class="fcol-1"></div>
                        <div class="fcol-5 d-flex align-center">
                            <attachment-list
                                [attachmentsHandler]="attachmentsHandler"
                                [allowUploads]="true"
                                [newTemplate]="true"
                                [allowDelete]="true"
                                [allowEdit]="true"
                                [disabled]="working"
                                [parentPromiseTracker]="workTracker"
                            >
                            </attachment-list>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="vertical-container">
                    <div class="form-group input-content top-buffer">
                        <div class="col-xs-12">
                            <button
                                class="btn btn-primary btn-sm"
                                type="button"
                                (click)="drawNoticeArea()"
                                [disabled]="working"
                            >
                                {{ hasLocation ? 'Edit' : 'Draw' }}
                                LOTAM Area
                            </button>
                            <span class="left-buffer right-buffer"> or </span>
                            <button
                                *ngIf="!hasLocation"
                                class="btn btn-default btn-sm"
                                type="button"
                                [disabled]="working"
                                data-cy="chooseLocationTemplate"
                                (click)="setNoLocation()"
                            >
                                No LOTAM Area
                            </button>
                            <button
                                *ngIf="hasLocation"
                                class="btn btn-danger btn-sm"
                                type="button"
                                [disabled]="working"
                                data-cy="chooseLocationTemplate"
                                (click)="setNoLocation()"
                            >
                                Delete LOTAM Area
                            </button>
                        </div>
                    </div>
                    <div *ngIf="!hasLocation" class="alert alert-info">
                        No applicable LOTAM area
                    </div>
                </div>
                <flyfreely-map
                    *ngIf="hasLocation"
                    #map
                    [organisationId]="organisation.id"
                    class="fill"
                    [features]="locationFeatures"
                    [requireCtrlToZoom]="true"
                    [mapData]="mapData$ | async"
                    [enableLayerGroupsByDefault]="['LOTAM']"
                    style="width: 100%; height: Calc(100vh - 324px)"
                    (featuresLoaded)="map.zoomToAllFeatures(true)"
                >
                </flyfreely-map>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default" type="button" (click)="onCancel()">
            Cancel
        </button>
        <button
            class="btn btn-primary"
            type="button"
            [tooltip]="submitButtonTooltip"
            [disabled]="
                working || lotamForm.invalid || (!isNew && lotamForm.pristine)
            "
            (click)="onSave()"
        >
            {{ submitButtonText }}
        </button>
        <button
            *ngIf="!isNew && canVoidAcknowledgement"
            class="btn btn-primary"
            type="button"
            tooltip="Save all changes and void all previous acknowledgements of this LOTAM"
            placement="top"
            [disabled]="working || lotamForm.invalid || lotamForm.pristine"
            (click)="voidAllAcknowledgements()"
        >
            Save and Void Acknowledgements
        </button>
    </div>
</ng-container>
